/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * device-mockup-tool-server
 * OpenAPI spec version: 1.10.0
 */
import type {ContactFormRequest, ContactFormResponse} from '../../model'

import {customFetch} from '../../../mutator/customFetch'

/**
 * Public contact form endpoint. Verifies reCAPTCHA v3 then logs the message (mailer is TODO).
 */
export type submitResponse200 = {
  data: ContactFormResponse
  status: 200
}

export type submitResponseSuccess = submitResponse200 & {
  headers: Headers
}
export type submitResponse = submitResponseSuccess

export const getSubmitUrl = () => {
  return `/contact/submit`
}

export const submit = async (
  contactFormRequest: ContactFormRequest,
  options?: RequestInit,
): Promise<submitResponse> => {
  return customFetch<submitResponse>(getSubmitUrl(), {
    ...options,
    method: 'POST',
    headers: {'Content-Type': 'application/json', ...options?.headers},
    body: JSON.stringify(contactFormRequest),
  })
}
